(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ggUuR", function(module, exports) {
$parcel$export(module.exports, "PasswordResetPage", function () { return (parcelRequire("jKLAS")).PasswordResetPage; });
parcelRequire("jKLAS");

});
parcelRegister("jKLAS", function(module, exports) {

$parcel$export(module.exports, "PasswordResetPage", function () { return $5a1f98fef4a01b99$export$5bbd98196cb66ba8; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dfqEP = parcelRequire("dfqEP");

var $dtmHG = parcelRequire("dtmHG");

var $6XZZX = parcelRequire("6XZZX");

var $i8p4K = parcelRequire("i8p4K");

var $1ze6N = parcelRequire("1ze6N");

var $egPoG = parcelRequire("egPoG");

var $jOjg2 = parcelRequire("jOjg2");

var $cKLZH = parcelRequire("cKLZH");

var $bdSQ8 = parcelRequire("bdSQ8");

var $drnpl = parcelRequire("drnpl");
parcelRequire("kTTMl");
var $3O0oJ = parcelRequire("3O0oJ");

var $gQ0Fu = parcelRequire("gQ0Fu");

var $9yk5s = parcelRequire("9yk5s");
const $5a1f98fef4a01b99$var$SFormWrapper = (0, $dfqEP.default)((0, $cKLZH.SContentWrapper))`
    width: 100%;
    max-width: 435px;
`;
function $5a1f98fef4a01b99$export$5bbd98196cb66ba8({ className: className, style: style }) {
    const text = (0, $9yk5s.default)();
    const { value: value, apply: apply } = (0, $egPoG.default)({
        password: "",
        passwordCompare: ""
    });
    const [error, setError] = (0, $iJHfq.useState)("");
    const [submitError, setSubmitError] = (0, $iJHfq.useState)(false);
    const [showPassword, toggleShowPassword] = (0, $iJHfq.useState)(false);
    const [showPasswordCompare, toggleShowPasswordCompare] = (0, $iJHfq.useState)(false);
    const navigate = (0, $dtmHG.useNavigate)();
    const [searchParams] = (0, $dtmHG.useSearchParams)();
    const { execute: resetPassword, status: status } = (0, $i8p4K.default)((token, value)=>(0, $drnpl.default)(token, value).then(()=>{
            (0, $gQ0Fu.default).setItem("notification", {
                text: "msgPasswordReset"
            });
            navigate("/login", {
                replace: true
            });
        }).catch(()=>setSubmitError(true)));
    const handleSubmit = (0, $iJHfq.useCallback)((event)=>{
        event.preventDefault();
        const token = searchParams?.get("token");
        if (!token) return;
        if (value.password !== value.passwordCompare) {
            setError(text("msgPasswordDoNotMatch"));
            return;
        }
        if (!(0, $6XZZX.isPasswordLongEnough)(value.password)) {
            setError(text("msgPasswordToShortSignup"));
            return;
        }
        resetPassword(token, value);
    }, [
        value,
        searchParams
    ]);
    const changeValue = (value)=>{
        setError("");
        apply(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style,
        background: "#ffffff",
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($5a1f98fef4a01b99$var$SFormWrapper, null, submitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SNotification), {
        "data-testid": "signInError",
        error: submitError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "msgPasswordNotChanged"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $jOjg2.FormHeader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "passwordForm",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $bdSQ8.PasswordInput), {
        label: value.password.length > 0 ? text("lblPassword") : "",
        placeholder: text("lblPassword"),
        onChange: (value)=>changeValue({
                password: value
            }),
        showPassword: showPassword,
        message: !value.password ? text("msgMinimumPasswordLength") : null,
        error: error,
        errorTestId: "passwordInputError",
        toggleShowPasswordFlag: toggleShowPassword,
        hasText: value.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $bdSQ8.PasswordInput), {
        label: value.passwordCompare.length > 0 ? text("lblConfirmPasswordField") : "",
        placeholder: text("lblConfirmPasswordField"),
        onChange: (value)=>changeValue({
                passwordCompare: value
            }),
        showPassword: showPasswordCompare,
        toggleShowPasswordFlag: toggleShowPasswordCompare,
        hasText: value.passwordCompare.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $3O0oJ.SubmitButton), {
        disabled: !value.password || !value.passwordCompare || status === (0, $i8p4K.Status).PENDING
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "btnResetPassword"
    }))))));
}

});
parcelRegister("6XZZX", function(module, exports) {

$parcel$export(module.exports, "MIN_PASSWORD_LENGTH", function () { return $a7c506b006042e04$export$6f63e37550343081; });
$parcel$export(module.exports, "MAX_FIRST_NAME_LENGTH", function () { return $a7c506b006042e04$export$8d95a259802f436c; });
$parcel$export(module.exports, "MAX_LAST_NAME_LENGTH", function () { return $a7c506b006042e04$export$a1ce64b0aabb67a7; });
$parcel$export(module.exports, "MAX_USER_EMAIL_LENGTH", function () { return $a7c506b006042e04$export$e457d43a6d8db9d4; });
$parcel$export(module.exports, "MAX_MOBILE_LENGTH", function () { return $a7c506b006042e04$export$b5adbff18555fae2; });
$parcel$export(module.exports, "isPasswordLongEnough", function () { return $a7c506b006042e04$export$ff7e0dbee5b5a1ba; });
const $a7c506b006042e04$export$6f63e37550343081 = 8;
const $a7c506b006042e04$export$8d95a259802f436c = 50;
const $a7c506b006042e04$export$a1ce64b0aabb67a7 = 50;
const $a7c506b006042e04$export$e457d43a6d8db9d4 = 50;
const $a7c506b006042e04$export$b5adbff18555fae2 = 50;
const $a7c506b006042e04$export$ff7e0dbee5b5a1ba = (password)=>password.length >= $a7c506b006042e04$export$6f63e37550343081;

});

parcelRegister("egPoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eff45df1bb9c9c9$export$2e2bcd8739ae039; });

var $iJHfq = parcelRequire("iJHfq");
const $6eff45df1bb9c9c9$var$isNaNType = (value)=>typeof value === "number" && isNaN(value);
const $6eff45df1bb9c9c9$var$isSame = (valueA, valueB)=>{
    if (typeof valueA !== typeof valueB) return false;
    if ($6eff45df1bb9c9c9$var$isNaNType(valueA) && $6eff45df1bb9c9c9$var$isNaNType(valueB)) return true;
    if (valueA === valueB) return true;
    if (typeof valueA !== "object") return false;
    if (valueA === null || valueB === null) return false;
    if (Array.isArray(valueA)) {
        if (!Array.isArray(valueB)) return false;
        if (valueA.length !== valueB.length) return false;
        return valueA.every((v, index)=>$6eff45df1bb9c9c9$var$isSame(v, valueB[index]));
    }
    const keysA = Object.keys(valueA);
    const keysB = Object.keys(valueB);
    if (keysA.length !== keysB.length) return false;
    if (keysA.some((key)=>!keysB.includes(key))) return false;
    return keysA.every((key)=>$6eff45df1bb9c9c9$var$isSame(valueA[key], valueB[key]));
};
const $6eff45df1bb9c9c9$var$selectDifferentProperties = (origin, patch)=>{
    return Object.keys(patch).reduce((diff, key)=>{
        return origin && key in origin && $6eff45df1bb9c9c9$var$isSame(patch[key], origin[key]) ? diff : Object.assign(diff, {
            [key]: patch[key]
        });
    }, {});
};
function $6eff45df1bb9c9c9$export$2e2bcd8739ae039(origin, patch) {
    const [diff, setDiff] = (0, $iJHfq.useState)({});
    return (0, $iJHfq.useMemo)(()=>({
            diff: diff,
            value: {
                ...origin,
                ...diff
            },
            apply: (changes)=>{
                const newDiff = patch ? patch(changes, diff, origin) : $6eff45df1bb9c9c9$var$selectDifferentProperties(origin, {
                    ...diff,
                    ...changes
                });
                setDiff(newDiff);
            },
            set: (changes)=>{
                const newDiff = patch ? patch(changes, {}, origin) : $6eff45df1bb9c9c9$var$selectDifferentProperties(origin, changes);
                setDiff(newDiff);
            },
            reset: ()=>setDiff({}),
            hasChanges: Boolean(Object.keys(diff).length)
        }), [
        origin,
        diff,
        setDiff
    ]);
}

});

parcelRegister("drnpl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d4d78d20bc5af4d$export$2e2bcd8739ae039; });

var $8F3Fq = parcelRequire("8F3Fq");
const $7d4d78d20bc5af4d$var$resetUserPassword = (token, data)=>(0, $8F3Fq.default)({
        method: "PUT",
        path: `/auth/password/reset/${token}`,
        body: data
    });
var $7d4d78d20bc5af4d$export$2e2bcd8739ae039 = $7d4d78d20bc5af4d$var$resetUserPassword;

});

parcelRegister("kTTMl", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return (parcelRequire("3O0oJ")).SubmitButton; });
parcelRequire("3O0oJ");

});
parcelRegister("3O0oJ", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $a264e3d8a0d55956$export$8b7b7cdfb85d78c5; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dfqEP = parcelRequire("dfqEP");

var $agk6O = parcelRequire("agk6O");

var $amdsM = parcelRequire("amdsM");

var $dz4Es = parcelRequire("dz4Es");
const $a264e3d8a0d55956$export$e97afde9f5f901c8 = (0, $dfqEP.default).button`
    display: flex;
    min-width: 150px;
    margin: 0 auto;
    padding: 9px 46px;
    border-radius: 16px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border: none;
    transition: 0.2s ease;
    font-size: 15px;
    svg {
        path {
            fill: ${({ theme: theme })=>theme.font.successColor};
        }
    }

    &[disabled],
    &[disabled]:active:not(:hover) {
        background-color: #e6e6e6;
        color: ${({ theme: theme })=>theme.font.lightestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &.inverted {
        background-color: #fff;
        color: #000;
    }

    &:hover {
        background-color: ${({ theme: theme })=>theme.font.successColor};
        color: #000;

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }
    &:active,
    &:active:not(:hover) {
        background-color: #d9edd9;
        color: ${({ theme: theme })=>theme.font.darkestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &[disabled]:hover {
        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
        color: ${({ theme: theme })=>theme.font.lightestColor};
        background-color: #e6e6e6;
    }
`;
function $a264e3d8a0d55956$export$8b7b7cdfb85d78c5({ children: children, className: className, style: style, inverted: inverted, disabled: disabled, loading: loading = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($a264e3d8a0d55956$export$e97afde9f5f901c8, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className, {
            inverted: inverted
        }),
        style: style,
        "data-testid": "submitButton",
        type: "submit",
        disabled: disabled
    }, children, " ", !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $dz4Es.SignInArrowIcon), {
        className: "ml-2"
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $agk6O.FontAwesomeIcon), {
        icon: (0, $amdsM.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }));
}

});




parcelRegister("5RT8K", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return (parcelRequire("18MiQ")).ResetPasswordRequestPage; });
parcelRequire("18MiQ");

});
parcelRegister("18MiQ", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return $a713b79bae86e888$export$d071176b85126a1a; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dfqEP = parcelRequire("dfqEP");

var $dtmHG = parcelRequire("dtmHG");

var $1ze6N = parcelRequire("1ze6N");

var $cKLZH = parcelRequire("cKLZH");

var $5gDWL = parcelRequire("5gDWL");

var $kFS0F = parcelRequire("kFS0F");

var $5ae1I = parcelRequire("5ae1I");

var $ktGyq = parcelRequire("ktGyq");

var $jOjg2 = parcelRequire("jOjg2");
parcelRequire("kTTMl");
var $3O0oJ = parcelRequire("3O0oJ");

var $9D3kj = parcelRequire("9D3kj");

var $9yk5s = parcelRequire("9yk5s");
const $a713b79bae86e888$var$SFormWrapper = (0, $dfqEP.default)((0, $cKLZH.SContentWrapper))`
    max-width: 510px;
    padding: 0 10px;
`;
const $a713b79bae86e888$var$SLink = (0, $dfqEP.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        text-align: center;
        width: 100%;
        display: inline-block;
        padding-top: 30px;
    }
`;
const $a713b79bae86e888$var$SInstruction = (0, $dfqEP.default).div`
    line-height: 1.5em;
    padding-bottom: 37px;
    text-align: center;
`;
const $a713b79bae86e888$var$SHeaderWrapper = (0, $dfqEP.default).div`
    padding-bottom: 45px;
`;
function $a713b79bae86e888$export$d071176b85126a1a({ className: className, style: style }) {
    const text = (0, $9yk5s.default)();
    const [email, setEmail] = (0, $iJHfq.useState)("");
    const [errorMessage, setErrorMessage] = (0, $iJHfq.useState)("");
    const navigate = (0, $dtmHG.useNavigate)();
    const [requestPasswordReset, { isLoading: isLoading }] = (0, $5gDWL.useAuthRequestPasswordResetMutation)();
    const handleSubmit = (0, $iJHfq.useCallback)((event)=>{
        event.preventDefault();
        if (!(0, $5ae1I.validateEmailFormat)(email)) {
            setErrorMessage(text("msgEmailFormatIncorrect"));
            return;
        }
        requestPasswordReset({
            userCredentials: {
                email: email
            }
        }).unwrap().then(()=>{
            navigate("/reset-password-request-success", {
                replace: true
            });
        }).catch((error)=>{
            if ((0, $kFS0F.getErrorMessageCode)(error) === "msgEmailDoesntExist") {
                setErrorMessage(text("msgEmailDoesntExist", {
                    company: "ChargeAmps"
                }));
                return;
            }
            navigate("/reset-password-request-error", {
                replace: true
            });
        });
    }, [
        email,
        navigate,
        requestPasswordReset,
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style,
        background: (0, $9D3kj.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($a713b79bae86e888$var$SFormWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($a713b79bae86e888$var$SHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $jOjg2.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($a713b79bae86e888$var$SInstruction, {
        "data-testid": "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "msgChargeAmpsResetPasswordInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "form",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $ktGyq.InputGroup), {
        errorTestId: "errorMsg",
        errorMsg: errorMessage,
        inverted: false,
        label: email && text("lblEmail")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $ktGyq.SInput), {
        placeholder: text("lblEmail"),
        onInput: (event)=>{
            const value = event.target.value;
            setErrorMessage("");
            setEmail(value);
        },
        value: email,
        "data-testid": "emailInput"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $3O0oJ.SubmitButton), {
        disabled: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "btnResetPassword"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($a713b79bae86e888$var$SLink, {
        as: (0, $dtmHG.Link),
        to: "/login",
        "data-testid": "returnBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "btnReturnToSignIn"
    }))));
}

});


parcelRegister("2st5z", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return (parcelRequire("ofrez")).ResetPasswordRequestSuccessPage; });
parcelRequire("ofrez");

});
parcelRegister("ofrez", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return $6215ad02eb21b9bd$export$4588528796d14202; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dtmHG = parcelRequire("dtmHG");
parcelRequire("D2Gjr");
var $3R56w = parcelRequire("3R56w");

var $cKLZH = parcelRequire("cKLZH");

var $1ze6N = parcelRequire("1ze6N");

var $9D3kj = parcelRequire("9D3kj");

var $9yk5s = parcelRequire("9yk5s");
function $6215ad02eb21b9bd$export$4588528796d14202({ className: className, style: style }) {
    const text = (0, $9yk5s.default)();
    const navigate = (0, $dtmHG.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style,
        background: (0, $9D3kj.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $3R56w.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>{
            navigate("/login", {
                replace: true
            });
        },
        type: (0, $3R56w.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("div", {
        "data-testid": "message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "msgResetPasswordLinkSent"
    }))));
}

});
parcelRegister("D2Gjr", function(module, exports) {
$parcel$export(module.exports, "LandingMessage", function () { return (parcelRequire("3R56w")).LandingMessage; });
$parcel$export(module.exports, "LandingMessageType", function () { return (parcelRequire("3R56w")).LandingMessageType; });
parcelRequire("3R56w");

});
parcelRegister("3R56w", function(module, exports) {

$parcel$export(module.exports, "LandingMessageType", function () { return $42a6ee82f1102ff8$export$ead8dc60ae5441ac; });
$parcel$export(module.exports, "LandingMessage", function () { return $42a6ee82f1102ff8$export$d88a99e06d24b3e0; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dfqEP = parcelRequire("dfqEP");
parcelRequire("dmgPw");
var $1ex3v = parcelRequire("1ex3v");
parcelRequire("dKosW");
var $ajcmw = parcelRequire("ajcmw");

var $8L6Pz = parcelRequire("8L6Pz");

var $9D3kj = parcelRequire("9D3kj");

var $jOjg2 = parcelRequire("jOjg2");
const $42a6ee82f1102ff8$var$SWrapper = (0, $dfqEP.default).div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $42a6ee82f1102ff8$var$SIcon = (0, $dfqEP.default).div`
    padding-bottom: 30px;
`;
const $42a6ee82f1102ff8$var$SBody = (0, $dfqEP.default).div`
    width: 550px;
    padding-bottom: 61px;
    line-height: 1.5em;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (max-width: 576px) {
        width: 100%;
    }
`;
const $42a6ee82f1102ff8$var$SLink = (0, $dfqEP.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        cursor: pointer;
    }
`;
var $42a6ee82f1102ff8$export$ead8dc60ae5441ac;
(function(LandingMessageType) {
    LandingMessageType["SUCCESS"] = "success";
    LandingMessageType["ERROR"] = "error";
    LandingMessageType["INFO"] = "info";
})($42a6ee82f1102ff8$export$ead8dc60ae5441ac || ($42a6ee82f1102ff8$export$ead8dc60ae5441ac = {}));
var $42a6ee82f1102ff8$export$ea871832d7359f7e;
(function(LandingMessageTitle) {
    LandingMessageTitle["DEFAULT"] = "MyChargeSpace";
    LandingMessageTitle["ADMIN"] = "HaloAdmin";
})($42a6ee82f1102ff8$export$ea871832d7359f7e || ($42a6ee82f1102ff8$export$ea871832d7359f7e = {}));
const $42a6ee82f1102ff8$var$renderIcon = (type)=>{
    if (type) {
        if (type === "success") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ex3v.LandingMessageSuccessIcon), null);
        if (type === "error") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $ajcmw.LandingMessageErrorIcon), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $8L6Pz.InfoIcon), {
            size: 90,
            fill: (0, $9D3kj.theme).brandColors.CA_Green
        });
    }
};
function $42a6ee82f1102ff8$export$d88a99e06d24b3e0({ title: title, type: type, linkText: linkText, onClick: onClick, children: children, className: className, style: style, icon: icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($42a6ee82f1102ff8$var$SWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $jOjg2.FormHeader), {
        "data-testid": "header",
        className: "mb-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($42a6ee82f1102ff8$var$SIcon, null, icon || $42a6ee82f1102ff8$var$renderIcon(type)), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("h4", {
        className: "m-0 mb-3"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($42a6ee82f1102ff8$var$SBody, null, children), linkText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($42a6ee82f1102ff8$var$SLink, {
        onClick: onClick,
        "data-testid": "linkBtn"
    }, linkText) : null);
}

});
parcelRegister("dmgPw", function(module, exports) {
$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return (parcelRequire("1ex3v")).LandingMessageSuccessIcon; });
parcelRequire("1ex3v");

});
parcelRegister("1ex3v", function(module, exports) {

$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return $163060741256305c$export$cd9c9d539c03064b; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");
function $163060741256305c$export$cd9c9d539c03064b({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("svg", {
        width: 90,
        height: 90,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("g", {
        fill: "#81E18B"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("path", {
        d: "m30.03 52.553 7.364 7.375 30.94-30.941 1.044 1.043-31.985 31.985-8.407-8.42-2.536-2.54-5.578-5.588 1.044-1.042 5.578 5.587 2.536 2.54Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475ZM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45Z"
    })));
}

});


parcelRegister("dKosW", function(module, exports) {
$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return (parcelRequire("ajcmw")).LandingMessageErrorIcon; });
parcelRequire("ajcmw");

});
parcelRegister("ajcmw", function(module, exports) {

$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return $6e702f32bf6580a2$export$651986bbbb409f50; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");
function $6e702f32bf6580a2$export$651986bbbb409f50({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 90,
        height: 90,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("g", {
        fill: "#DF0017"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("path", {
        d: "m63.596 27.08-5.902 5.9-1.844 1.845-28.77 28.77-1.044-1.043 28.77-28.77 1.845-1.844 5.901-5.902 1.044 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("path", {
        d: "M62.92 63.595 26.406 27.08l1.043-1.043 36.516 36.516-1.043 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement("path", {
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475zM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45z"
    })));
}

});






parcelRegister("j6d19", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return (parcelRequire("55SRp")).ResetPasswordRequestErrorPage; });
parcelRequire("55SRp");

});
parcelRegister("55SRp", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return $b5ff781f6e112c98$export$74ef4c4eee19ea3d; });

var $iJHfq = parcelRequire("iJHfq");

var $l5Eu7 = parcelRequire("l5Eu7");

var $dfqEP = parcelRequire("dfqEP");

var $dtmHG = parcelRequire("dtmHG");
parcelRequire("D2Gjr");
var $3R56w = parcelRequire("3R56w");

var $cKLZH = parcelRequire("cKLZH");

var $9D3kj = parcelRequire("9D3kj");

var $1ze6N = parcelRequire("1ze6N");

var $9yk5s = parcelRequire("9yk5s");
const $b5ff781f6e112c98$var$Title = (0, $dfqEP.default).div`
    font-size: 24px;
    padding-bottom: 20px;
`;
function $b5ff781f6e112c98$export$74ef4c4eee19ea3d({ className: className, style: style }) {
    const text = (0, $9yk5s.default)();
    const navigate = (0, $dtmHG.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $cKLZH.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($l5Eu7)))(className),
        style: style,
        background: (0, $9D3kj.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $3R56w.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $3R56w.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement($b5ff781f6e112c98$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iJHfq))).createElement((0, $1ze6N.default), {
        code: "lblSignUpError"
    })));
}

});


})();
//# sourceMappingURL=index.ebb4d918.js.map
